/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'gatsby';
import { get } from 'lodash';
import slugify from 'slugify';
import Layout from '~components/Layout';
import Topper from '~components/base/Topper';
import BodyElement from '~components/body/BodyElement';
import ArchieElement from '~components/body/ArchieElement';
//import Byline from '~components/base/Bylines';
import SeoSocial from '~components/base/SeoSocial';
import useBusiness from '~lib/useBusiness';
import GlobalStyles from '../styles/GlobalStyles';

import Buffer from '~components/graphics/Buffer';

import CustomTeasersData from '../custom_teasers.json';
import CustomTeasers from '~components/graphics/custom_teasers';

import CustomCredits from '~components/graphics/custom_credits';
import CustomCreditsData from '../custom_credits.json';

export const pageQuery = graphql`
    query {
        site {
          pathPrefix
          siteMetadata {
            title
            sectionName
            projectName
          }
        }
        story: arcStory(storyId: {eq: "UM3B24NW6VCF3DUJMHU5XYFU7M"}) {
            headlines {
                basic
            }
            subheadlines {
                basic
            }
            credits {
                name
                url
            }
            bodyElements {
              _id
              type
              subtype
              alignment
              content
              archieJson
              url
              srcSet
              caption
              subtype
              bodyElements {
                _id
                content
              }
              citation {
                content
              }
            }
            # getting seo social data
            promoImage {
              sizes {
                _1024
              }
            }
            description {
              basic
            }
            # getting teasers information
            relatedLinks {
              headlines {
                basic
              }
              promoImage {
                sizes {
                  _1024
                  _480
                  _640
                  _240
                }
                srcSet
                url
              }
              url
            }
            slug
        }
    }
`;

const ArticleTemplate = ({
  data: {
    story,
    site: {
      pathPrefix,
      siteMetadata: { sectionName, projectName },
    },
  },
}) => {
  const slugifiedSection = slugify(sectionName, { lower: true });
  const authorNames = get(story, 'credits', [])
    .map((credit) => credit.name)
    .join(', ');

  useBusiness({
    pageName: `${slugifiedSection} | ${get(story, 'headlines.basic')}`,
    environment: process.env.NODE_ENV,
    meterContent: (process.env.NODE_ENV !== 'development'),
    pageId: `apps.${story.slug}`,
    section: slugifiedSection,
    author: authorNames,
    projectName,
  });

  const subhed = get(story, 'subheadlines.basic')
    ? (<h3 className="subheadline miller-n4">{get(story, 'subheadlines.basic')}</h3>)
    : (null);
  const metaUrl = `https://apps.bostonglobe.com${pathPrefix}`;

  // testing for presence of publishDate archie element
  // if it exists, set the pubDateObj to it's value and pass to the Byline component below
  // if it doesn't pass null
  let pubDateObj = null;
  story.bodyElements.forEach((e) => {
    if (e.archieJson) {
      const parsedArchie = JSON.parse(e.archieJson);
      if (parsedArchie.publishDate !== undefined) {
        pubDateObj = parsedArchie;
      }
    }
  });

  //Sectioning - PART 1
  //Add  all buffers to array

  let sections = []; 
  let tempSection = [];   

  story.bodyElements.map((element) => {

    //Check if archie element. If not store element in temporary array 
    if (element.archieJson){
        
      let archieCopy = element.archieJson
      let archieObj = JSON.parse(archieCopy);

      if (archieObj.undergroundBuffer){
        sections.push(tempSection)
        tempSection = [];
      }

      tempSection.push(element)
    }else{
      tempSection.push(element)
    }
  });

  return (
    <Layout>
      <SeoSocial
        url={metaUrl}
        description={get(story, 'description.basic')}
        title={get(story, 'headlines.basic')}
        imageUrl={get(story, 'promoImage.sizes._1024')}
      />
      <GlobalStyles />
      <Topper>

      </Topper>
      <main id="main">
        <div className="rocks"></div>
        <div id="texture"></div>
        <div id="hole"></div>
        {// ISSUE
      

          //Sectioning - PART 2

          sections.map((secs, index) => {
           
            //Create parent arrays for content
            let content = [];
            let ticker =[];
            let footer=[];

            let secId = "section-"+index;
            let secDistance;
            let secTitle;


            //Format content accordingly (body vs archie)
            secs.map((el) => {
              if (el.archieJson) {

                let archieCopy = el.archieJson
                let archieObj = JSON.parse(archieCopy);
                
                //update distance
                if (archieObj.undergroundBuffer){
                  secDistance = archieObj.distance;
                  secTitle = archieObj.undergroundBuffer;
                }

                //Format Archie content: ticker, footer, rest
                if (archieObj.ticker){
                  ticker.push(
                    <ArchieElement
                      data={el}
                      key={el._id}
                      relatedLinks={get(story, 'relatedLinks')}
                    />
                  )
                }else if((archieObj.teaser)||(archieObj.credits)){
                  footer.push(
                    <ArchieElement
                      data={el}
                      key={el._id}
                      relatedLinks={get(story, 'relatedLinks')}
                    />
                  )
                }else{
                  content.push(
                    <ArchieElement
                      data={el}
                      key={el._id}
                      relatedLinks={get(story, 'relatedLinks')}
                    />
                  )
                }
              }else{ //Build body content
                content.push(
                  <BodyElement
                    data={el}
                    key={el._id}
                  />
                )
              }
            })

            return(
              <div>
                {ticker}
              
                <Buffer
                  id={secId}
                  distance = {secDistance}
                  content={content}
                />
              </div>
            )
        })
        }
      </main>
      <div id="custom-footer">
        <CustomTeasers relatedlinks={CustomTeasersData.relatedLinks} />
        <CustomCredits credits={CustomCreditsData.credits} />
      </div>
    </Layout>
  );
};


ArticleTemplate.propTypes = {
  data: PropTypes.shape({
    story: PropTypes.shape({
      bodyElements: PropTypes.arrayOf(
        PropTypes.shape({
          archieJson: PropTypes.string,
        }),
      ),
      slug: PropTypes.string,
    }),
    site: PropTypes.shape({
      pathPrefix: PropTypes.string.isRequired,
      siteMetadata: PropTypes.shape({
        title: PropTypes.string.isRequired,
        sectionName: PropTypes.string.isRequired,
        projectName: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
  }).isRequired,
  pageContext: PropTypes.shape({
    storyId: PropTypes.string,
  }).isRequired,
};

export default ArticleTemplate;
